<form class="login-container" [formGroup]="formGroup" (submit)="login()">
    <div class="logo"></div>

    <div class="login-title">
        {{ 'Login.Login' | translate }}
    </div>

    <div class="login-form">
        <!-- user selection for development -->
        @if (!isProduction && users.length > 0) {
            <mat-form-field>
                <mat-select placeholder="Select User" (selectionChange)="selectUser($event)">
                    @for (user of users; track user.userId) {
                        <mat-option [value]="user">
                            {{ user.label }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }

        <mat-form-field>
            <mat-icon matPrefix>mail</mat-icon>
            <input
                #userInput
                cdkFocusInitial
                matInput
                type="email"
                formControlName="userId"
                placeholder="{{ 'Login.Email' | translate }}" />
        </mat-form-field>
        <mat-form-field>
            <mat-icon matPrefix>lock_outline</mat-icon>
            <input #passwordInput matInput type="password" formControlName="password" placeholder="{{ 'Login.Password' | translate }}" />
        </mat-form-field>
    </div>

    <div class="login-buttons">
        <div class="btns-spacer"></div>
        @if (!isEntering) {
            <button mat-stroked-button type="submit">{{ 'Login.LoginButton' | translate }}</button>
        }
        @if (isEntering) {
            <mat-spinner [diameter]="24" />
        }
    </div>
</form>
